<template>
  <div class="media-preview">
    <div class="media-header">
      <div class="d-flex justify-content-start align-items-center">
        <div>
          <h1 class="d-flex justify-content-start align-items-center">
            {{ title }}
          </h1>
          <h3>
            {{ subtitle }}
          </h3>
        </div>
        <div
          v-if="showControl"
          class="border-left ml-3 pl-3"
          style="border-width: 3px !important"
        >
          <button
            v-if="computedControls.delete"
            class="btn btn-danger btn-sm mx-2"
            @click="$emit('delete', defect)"
          >
            <font-awesome-icon :icon="['fas', 'trash-alt']" />
          </button>
          <button
            v-if="computedControls.add"
            class="btn btn-success btn-sm mx-2"
            @click="$emit('add', defect)"
          >
            <font-awesome-icon :icon="['fas', 'plus']" />
          </button>
          <button
            v-if="computedControls.remove"
            class="btn btn-warning btn-sm mx-2"
            @click="$emit('remove', defect)"
          >
            <font-awesome-icon :icon="['fas', 'minus']" />
          </button>
        </div>
      </div>
      <div>
        <div class="btn-group mr-4" v-if="hasNavigation">
          <button
            class="btn light border shadow-sm btn-sm"
            @click="navigatePrevious()"
            :disabled="!hasNavigation.previous"
          >
            <font-awesome-icon :icon="['fas', 'angle-left']" />
          </button>
          <button
            class="btn light border shadow-sm btn-sm"
            @click="navigateNext()"
            :disabled="!hasNavigation.next"
          >
            <font-awesome-icon :icon="['fas', 'angle-right']" />
          </button>
        </div>
        <button class="btn-close" @click="closePreview">&times;</button>
      </div>
    </div>
    <div class="media-container p-0">
      <div class="placeholder" v-if="isLoading">
        <div class="spinner-border text-primary mr-3"></div>
        <span class="text-muted">Loading preview...</span>
      </div>
      <div id="osd" :class="{ invisible: isLoading }"></div>
      <div
        class="dashcam-map"
        :class="{
          invisible:
            !showMap || isNaN(this.defect.lat) || isNaN(this.defect.lng),
        }"
      >
        <div id="map" class="rounded overflow-hidden"></div>
        <Pin :key="mapPin._id" :map="map" :caseItem="mapPin" v-if="mapPin" />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "mapbox-gl";
import Pin from "@/components/Pin";
import OSD from "openseadragon";

export default {
  name: "media-preview",
  props: [
    "url",
    "title",
    "subtitle",
    "component",
    "showMap",
    "defect",
    "showControl",
    "hasNavigation",
  ],
  components: {
    Pin,
  },
  data() {
    return {
      map: null,
      mapPin: null,
      osd: null,
      isLoading: false,
      computedControls: {
        delete: false,
        add: false,
        remove: false,
      },
    };
  },
  watch: {
    showControl: {
      handler() {
        if (this.showControl) {
          this.computedControls = this.showControl;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    navigatePrevious() {
      this.$emit("navigate", "previous");
    },
    navigateNext() {
      this.$emit("navigate", "next");
    },
    initMap() {
      return new Promise((resolve) => {
        mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_KEY;

        if (!isNaN(this.defect.lat) && !isNaN(this.defect.lng)) {
          if (!this.map) {
            this.map = new mapboxgl.Map({
              container: "map",
              style: "mapbox://styles/mapbox/dark-v9",
              center: [this.defect.lng, this.defect.lat],
              zoom: 10,
            });

            this.map.on("load", () => {
              resolve();
            });
          } else {
            this.map.setCenter([this.defect.lng, this.defect.lat]);
            this.map.setZoom(14);
          }

          this.mapPin = this.defect;
        }
      });
    },
    closePreview() {
      if (!this.isLoading) {
        $("body").off("keydown");

        if (this.map) {
          this.map.remove();

          this.map = null;
        }

        this.$nextTick(() => {
          this.$emit("close");
        });
      }
    },
  },
  mounted() {
    this.isLoading = true;

    this.osd = OSD({
      id: "osd",
      prefixUrl: "/osd/",
      crossOriginPolicy: "Anonymous",
      maxZoomPixelRatio: 10,
      navigationControlAnchor: OSD.ControlAnchor.ABSOLUTE,
    }).open({
      type: "image",
      url: `${this.url}`,
    });

    this.osd.addHandler("open", (res) => {
      if (this.showMap) {
        this.initMap();
      }

      $("body").on("keydown", (e) => {
        if (e.key == "ArrowLeft") {
          this.navigatePrevious();
        } else if (e.key == "ArrowRight") {
          this.navigateNext();
        }
      });

      this.isLoading = false;
    });
  },
  beforeDestroy() {
    this.closePreview();
  },
};
</script>